module.exports = __webpack_public_path__ + "img/ruffle_length.7789757e.png";